// `Type.Value` of an item in api/v2/notifications.
export const Notification = {
    FollowGallery: 0,
    Like: 1,
    Inquiry: 2,
    Followup: 3,
    Impression: 4,
    Arrivals: 5,
    MessageOpen: 6,
    FollowArtist: 7,
    ArrivalsSent: 8,
    Activity: 9,
    ReleaseNote: 10,
    ConsignmentTerm: 11,
    PaymentOnDeclinedInvoice: 13
} as const;

// The types the bell, the Notifications page and the home card can render. The API
// leaves out any other type, so a new one stays hidden until it is added here.
export const KNOWN_NOTIFICATION_TYPES: readonly number[] = [
    Notification.FollowGallery,
    Notification.Like,
    Notification.Inquiry,
    Notification.FollowArtist,
    Notification.Activity,
    Notification.ReleaseNote,
    Notification.ConsignmentTerm,
    Notification.PaymentOnDeclinedInvoice
];

export function isKnownNotificationType(notification: { Type?: { Value?: number } | null }): boolean {
    return KNOWN_NOTIFICATION_TYPES.includes(notification.Type?.Value ?? -1);
}

// Stable row identity: the NotificationId alone repeats across types.
export const notificationKey = (d: { Type?: { Value?: number } | null; NotificationId: number | string }) =>
    `${d.Type?.Value}_${d.NotificationId}`;

// Indexed keys (`knownTypes[0]=0`), the form the API binds to a list.
export function knownTypesParams(): Record<string, number> {
    return Object.fromEntries(KNOWN_NOTIFICATION_TYPES.map((value, i) => [`knownTypes[${i}]`, value]));
}
